import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useGetShopByIdQuery,
  useGetUserShopsByBusinessTypeQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../features/shop/shopApiSlice";

export const useManufacturerOwnerProfileState = (shopId) => {
  const { name } = useSelector((state) => state.user);
  const [suggest, setSuggest] = useState(0);
  const [suggestdetail, setSuggestdetail] = useState(0);
  const [suggestdata, setSuggestdata] = useState([]);

  const { data: shopResponse, isLoading: loadingShop } = useGetShopByIdQuery(shopId, {
    skip: !shopId,
    refetchOnMountOrArgChange: true,
  });

  const shopData = shopResponse?.data?.Shop;

  const { data: userShopsResponse } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "manufacturerShop" },
    { skip: !name?._id },
  );

  const [triggerVendorSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  useEffect(() => {
    const fromThisShop =
      shopData?.shopCategory?.name || shopData?.shopCategory || "";
    const fromFirst =
      userShopsResponse?.data?.Shops?.[0]?.shopCategory?.name || "";
    const resolved =
      (typeof fromThisShop === "string" && fromThisShop.trim()) ||
      (typeof fromFirst === "string" && fromFirst.trim()) ||
      "";
    if (resolved) {
      localStorage.setItem("mycategory", resolved);
    }
  }, [shopData, userShopsResponse]);

  const suggestdatta = useCallback(async () => {
    const vendorid = shopData?._id;
    if (!vendorid) return;

    try {
      const response = await triggerVendorSuggestions(vendorid).unwrap();
      const suggestions =
        response?.data?.[0]?.suggestions ||
        response?.[0]?.suggestions ||
        response?.data?.suggestions ||
        response?.suggestions ||
        [];
      setSuggestdata(suggestions);
    } catch (err) {
      console.error("Failed to load manufacturer shop suggestions", err);
    }
  }, [shopData?._id, triggerVendorSuggestions]);

  return {
    shopData,
    loadingShop,
    suggest,
    setSuggest,
    suggestdetail,
    setSuggestdetail,
    suggestdata,
    setSuggestdata,
    suggestdatta,
  };
};

export default useManufacturerOwnerProfileState;
